module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIxLjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjkiLz4KPHBhdGggZD0iTTE1IDkuNWMtLjUtMS0xLjYtMS41LTMtMS41LTEuNyAwLTMgLjgtMyAyczEuMyAxLjcgMyAyIDMgLjggMyAyLTEuMyAyLTMgMmMtMS40IDAtMi42LS42LTMtMS42TTEyIDZ2Mm0wIDh2MiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sidebar/fee-claims-white.svg
// module id = 617
// module chunks = 2